import React from "react";

import "./Footer.scss";

function Footer() {
    return (
        <section id="footer">
            <div className="footer-container">
                <div className="footer-widget">
                    <div className="widget-top">
                        <div className="box-left">
                            <h2>Get in touch</h2>
                            <a className="underline-hover" href="mailto:nicola.abu.shaibeh@gmail.com">nicola.abu.shaibeh@gmail.com</a>
                        </div>
                        <div className="box-center">

                        </div>
                        <div className="box-right">
                            <h2>SOCIAL</h2>
                            <ul>
                                <li>
                                    <a className="underline-hover" href="https://www.linkedin.com/in/nicolaabushaibeh/" target="_blank" >
                                        <svg xmlns="http://www.w3.org/2000/svg" id="SVGRoot" viewBox="0 0 32 32"><path d="m9 2a1 1 0 0 0 -1 1 1 1 0 0 0 1 1h17.586l-24.293 24.293c-.39042.39051-.39042 1.0236 0 1.4141.39051.39042 1.0236.39042 1.4141 0l24.293-24.293v17.586a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-20a1.0001 1.0001 0 0 0 -1-1h-20z"></path></svg>
                                        <span className="Social-text">LinkedIn</span>
                                    </a>
                                </li>
                                <li>
                                    <a className="underline-hover" href="https://www.github.com/NicolaLino" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" id="SVGRoot" viewBox="0 0 32 32"><path d="m9 2a1 1 0 0 0 -1 1 1 1 0 0 0 1 1h17.586l-24.293 24.293c-.39042.39051-.39042 1.0236 0 1.4141.39051.39042 1.0236.39042 1.4141 0l24.293-24.293v17.586a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-20a1.0001 1.0001 0 0 0 -1-1h-20z"></path></svg>
                                        <span className="Social-text">GitHub</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="elements">
                    <div className="element-left">
                        <h3>Copyright © 2023 | Nicola Abu Shaibeh. This site still under development 🖤</h3>
                    </div>
                    <div className="element-right">
                        <h3>version 1.00</h3>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Footer;